import { createSelector } from '@reduxjs/toolkit';

import { convertMapBoundsToBbox } from '@/microfrontends/map/shared/utils/map/convertMapBoundsToBbox';

import { type IBBoxSchema } from '@/repositories/generated/shared/search-offers-index/entities/bbox/BBoxSchema';

import { useReduxSelector } from '../../../hooks';
import { type MapBounds, type MapConfigurationState } from '../slice';

import { mapConfigurationBoundsSelector, mapConfigurationCenterSelector, mapConfigurationZoomSelector } from './dumb';

export const mapConfigurationBboxSelector = createSelector(mapConfigurationBoundsSelector, bounds =>
  convertMapBoundsToBbox(bounds as MapBounds),
);

export function useMapConfigurationBboxSelector(): IBBoxSchema {
  return useReduxSelector(mapConfigurationBboxSelector);
}

export const mapConfigurationInitialStateSelector = createSelector(
  mapConfigurationCenterSelector,
  mapConfigurationZoomSelector,
  (center, zoom) => ({ center, zoom }),
);

export function useMapConfigurationInitialStateSelector(): Pick<MapConfigurationState, 'center' | 'zoom'> {
  return useReduxSelector(mapConfigurationInitialStateSelector);
}
